import { ACCESSIBILITY_TAGS } from "../constants/accessibility-tags";

export class Accessibility {
  // The index signature tells TypeScript that the class has dynamic properties of type boolean
  [key: string]: boolean | ((type: "short" | "long") => string[]);

  constructor() {
    // Loop over the array and create properties for each tag in the ACCESSIBILITY_TAGS array
    ACCESSIBILITY_TAGS.forEach((accessibilityTag) => {
      // Initialize each tag property with a value of `false`
      this[accessibilityTag.tag] = false;
    });
  }

  // Optional method to get a description for a tag
  getDescriptions(type: "short" | "long"): string[] {
    return ACCESSIBILITY_TAGS
      .filter((accessibilityTag) => this[accessibilityTag.tag]) // Only enabled options
      .map((tag) => tag[type]); // This assumes you have a short/long property in each tag object
  }
}
